<template>
  <div class="form">
    <div class="form__block">
      <p>{{ t('fields.email') }}</p>
      <ui-input
        :type="'text'"
        :placeholder="t('fields.email')"
        :rules="[isEmail]"
        v-model="email"
      />
    </div>
    <div class="form__block">
      <p>{{ t('fields.password') }}</p>
      <ui-input
        :type="'password'"
        :placeholder="t('fields.password')"
        :rules="[required]"
        v-model="password"
      />
    </div>
    <ui-button
        class="form__button"
        :isLoading="isLoading"
        :isDisabled="!isFormValid"
        @click="login"
    >
      {{ t('buttons.login') }}
    </ui-button>
    <div class="form__actions">
      <router-link :to="translations.i18nRoute({ name: 'forgot-password' })" class="form__actions-link">{{ t('login.forgot') }}</router-link>
      <router-link :to="translations.i18nRoute({ name: 'register' })" class="form__actions-text">{{ t('login.register') }}</router-link>
    </div>
  </div>
</template>

<script setup>
import UiInput from "@/components/ui/ui-input.vue";
import {useI18n} from "vue-i18n";
import {isEmail, required} from "@/core/rules/textFieldRules.js";
import {computed, ref} from "vue";
import UiButton from "@/components/ui/ui-button.vue";
import translations from "@/core/helpers/translations.js";
import {Auth} from "@/core/api/auth.js";
import {useAuthStore} from "@/stores/auth.js";
import {Orders} from "@/core/api/orders.js";
import {useCartStore} from "@/stores/cart.js";
import {useRouter} from "vue-router";
import {ElNotification} from "element-plus";
import {Wishlist} from "@/core/api/wishlist.js";
import {useWishlistStore} from "@/stores/wishlist.js";

const {t} = useI18n()
const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()
const router = useRouter()

const email = ref('')
const password = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true &&
    required(password.value) === true
  )
})

const login = async () => {
  isLoading.value = true

  const res = await Auth.login(email.value, password.value)

  if (!res.errors) {
    authStore.setUser({
      user: res.data.obtainJwtToken.user,
      accessToken: res.data.obtainJwtToken.accessToken
    })

    // if (res.data.obtainJwtToken.user.language !== translation.currentLocale) {
    //   translations.switchLanguage(res.data.obtainJwtToken.user.language)
    // }

    await router.push({
      name: 'home',
      params: {
        locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
      }
    })

    localStorage.setItem('fpt-refresh', res.data.obtainJwtToken.refreshToken)

    const currentOrder = await Orders.getOrders("PENDING", res.data.obtainJwtToken.accessToken, res.data.obtainJwtToken.user.email)
    cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)

    const wishlistRes = await Wishlist.getWishlist(res.data.obtainJwtToken.accessToken)
    wishlistStore.wishlist = wishlistRes.data.wishlists.edges[0].node
  } else {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }

  isLoading.value = false
}
</script>

<style lang="scss" scoped>
.form {
  position: relative;
  z-index: 1;
  width: 585px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;

    & p {
      color: #5B194F;
      font-size: 16px;
      font-weight: 600;
    }
  }

  &__button {
    width: fit-content;
    padding-inline: 50px;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 7px;

    &-link {
      transition: 0.2s;
      color: #5b194f;
      font-size: 14px;
      font-weight: 500;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;

      &:hover {
        color: #912f7e;
      }
    }

    &-text {
      text-decoration: underline;
      transition: 0.2s;
      color: #6C6C6C;
      font-size: 14px;
      font-weight: 400;

      &:hover {
        color: #333333;
      }
    }
  }
}

@media (max-width: 650px) {
  .form {
    width: 100%;
  }
}
</style>